/* eslint import/no-extraneous-dependencies: 0 */

import 'bootstrap';

import User from 'app/models/user';
import Base from 'app/views/base';

import { setLocation } from 'utils/wrappers';
import { displayErrorOnField, displayErrorsOnView, clearPopoversOnView } from 'utils/forms';
import { showError, getResponseErrors } from 'utils/messages';

import tmpl from 'templates/user_create';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #user_create_form': 'submit',
    'keyup input': 'clearPopover',
  },

  initialize(options = {}) {
    this.model = new User({});
    this.redirect = options.redirect;
  },

  context() {
    return {
      name: this.model.get('name'),
      email: this.model.get('email'),
      phone_number: this.model.get('phone_number'),
    };
  },

  afterRender() {
    this.setFocus('name');
  },

  submit(e) {
    const self = this;
    e.preventDefault();

    this.model.save({
      name: this.$('input#signup-name').val(),
      email: this.$('input#signup-email').val(),
      phone_number: this.$('input#signup-phone_number').val(),
      password: this.$('input#signup-password').val(),
      password_confirmation: this.$('input#signup-password_confirmation').val(),
    }, {
      success: function successFunction() {
        if (this.redirect) {
          setLocation(this.redirect);
        } else {
          setLocation('/verification');
        }
      }.bind(this),
      error(model, response) {
        clearPopoversOnView(self);
        self.render();

        if (response.status >= 500) {
          showError('There was a problem communicating with the EasyPost servers. You may continue using the logged-out functionality of the website while this problem is resolved.');
        } else {
          const errors = getResponseErrors(response);
          displayErrorsOnView(self, errors, ['name', 'email', 'phone_number', 'password', 'password_confirmation']);
        }
      },
    });
  },

  setFocus(attribute) {
    this.$(`#signup-${attribute}`).focus();
  },

  displayError(attribute, message) {
    const formField = this.$(`#signup-${attribute}`);
    displayErrorOnField(formField, message);
  },

  clearPopover(e) {
    $(e.currentTarget).popover('hide');
  },
});



// WEBPACK FOOTER //
// ./app/views/user_create_view.js